/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import Title from "./Title";
import iconAgregar from "../../../assets/pepper-icons/rightbar/icon_agregar.svg";
import { useDispatch, useSelector } from "react-redux";
import { importAlertState } from "../../../redux/actions/alert";
import { changeData } from "../../../utils/changeData";
import {
  GetAreas,
  PostInitialBalance,
  PostManualDocument,
  CreateCreditsDocument,
} from "../../../graphql/addSource";
import {
  UpdateManualDocument,
} from "../../../graphql/updateSource";
import { cashFlowCategories } from "../../../redux/actions/flujocaja";
import { GetCashflowCategories } from "../../../graphql/cashflowAreas";
import { GetHeaders } from "../../../utils/getHeaders";
import { formatMoney } from "../../../utils/formatter";
import moment from "moment";
import { sendUpdateForm, sendSubmitForm } from "./actionForm/actionForm";
import TextArea from "./formTypes/textArea";
import Button from "./formTypes/button";
import MultiSelectComp from "./formTypes/multiSelect";
import SubtitleTop from "./formTypes/subtitleTop";
import SubtitleFooter from "./formTypes/subtitleFooter";
import Select from "./formTypes/selectType";
import CreditType from "./formTypes/creditType";
import BankSelect from "./formTypes/bankSelect";
import RepeatSelect from "./formTypes/repeatSelect";
import PaySelect from "./formTypes/paySelect";
import CurrencySelect from "./formTypes/currencySelect";
import InputAmount from "./formTypes/inputAmount";
import CreditId from "./formTypes/creditId";
import PaymentsAmount from "./formTypes/paymentsAmount";
import Payments from "./formTypes/payments";
import Fees from "./formTypes/fees";
import FeesPeriod from "./formTypes/feesPeriod";
import Area from "./formTypes/area";
import Name from "./formTypes/name";
import FirstDate from "./formTypes/firstDate";
import LastDate from "./formTypes/lastDate";
import Multiple from "./formTypes/multiple";
import SubmitButton from "./formTypes/submitButton";
import ButtonGroup from "./formTypes/buttonGroup";
import { DeleteDocument } from "src/graphql/taxDocument";

const Form = ({
  title,
  closeMenu,
  forms,
  type,
  options,
  SelectedForm,
  editData,
  setDataFunction,
  setCheckedTransactions,
  onToggleExpand,
  isExpanded,
  panelClassName = "",
}) => {
  const [nameVisited, setNameVisited] = useState(false);
  const [commentVisited, setCommentVisited] = useState(false);
  const [typeVisited, setTypeVisited] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [buttonState, setButtonState] = useState(true);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [credit, setCredit] = useState({});
  const dispatch = useDispatch();
  const { selectedCompany } = useSelector((state) => state.companyList);
  const { manualDocumentInfo } = useSelector((state) => state.manualDocument);
  const companyId = selectedCompany.id;
  const messageError = "Este campo es obligatorio";
  const areas = GetAreas(companyId);
  let getDate = moment(data?.date).toDate();
  let getEndDate = moment(data?.finalDate).toDate();
  let getCreditDate = moment(credit?.firstDate).toDate();
  let getCreditEndDate = moment(credit?.finalDate).toDate();
  const {
    data: allCategories,
    fetching: fetchCategories,
    reexecuteQuery: getCategories,
  } = GetCashflowCategories({ companyId });
  let { cashFlowCategories: createdCategories, updateNeeded } = useSelector(
    (state) => state.flujocaja
  );
  createdCategories = createdCategories
    ? Object?.values(createdCategories)
    : null;
  // useEffect(() => {
  //   if (!fetchCategories && allCategories)
  //     dispatch(
  //       cashFlowCategories(
  //         allCategories?.findCashflowCategories?.categories || {}
  //       )
  //     );
  // }, [fetchCategories]);

  // useEffect(() => {
  //   if (updateNeeded) getCategories({ requestPolicy: "network-only" });
  // }, [updateNeeded]);

  const postInitialBalance = PostInitialBalance();
  const postManualDocument = PostManualDocument();
  const createCreditsDocument = CreateCreditsDocument();
  const { updateManualDocument } = UpdateManualDocument();
  const { executeMutation: deleteManualDocument, fetching: deleteLoading } = DeleteDocument();
  const getFullHeaders = (value) => {
    const category = createdCategories?.find(
      (category) => category?.category == value
    );
    const header = GetHeaders(value);
    return category?.name || header;
  };

  useEffect(() => {
    if (data.name && data.entryType) {
      setShowDetail(true);
    }
    if (!data.name && !data.entryType) {
      setShowDetail(false);
    }
  }, [data?.entryType, data?.comment, data?.name]);

  useEffect(() => {
    if (manualDocumentInfo?.selected) {
      if (manualDocumentInfo?.selected[0]?.documentType !== "MANUAL") {
        dispatch(
          importAlertState({
            content: "El documento seleccionado no es de tipo manual",
            state: "error",
            duration: 3,
          })
        );
        closeMenu();
      } else {
        setData({
          name: manualDocumentInfo?.selected
            ? manualDocumentInfo?.selected[0].document.name
            : data?.name,
          entryType: manualDocumentInfo?.selected
            ? !manualDocumentInfo?.selected[0]?.document?.meta?.repeating
              ? "singleEntry"
              : manualDocumentInfo?.selected[0]?.document?.meta?.repeating
                ? "recurrent"
                : data.entryType
            : data.entryType,
          comment: manualDocumentInfo?.selected
            ? manualDocumentInfo?.selected[0].document.description
            : data?.comment,
          area: manualDocumentInfo?.selected
            ? manualDocumentInfo?.selected[0]?.document?.cashflowArea?.id
            : data?.area,
          date: manualDocumentInfo?.selected
            ? moment(manualDocumentInfo?.selected[0]?.date).format("yyyy-MM-DD")
            : "",
          finalDate: manualDocumentInfo?.selected
            ? moment(
              manualDocumentInfo?.selected[0]?.document?.meta?.until
            ).format("yyyy-MM-DD")
            : "",
          amount: manualDocumentInfo?.selected
            ? manualDocumentInfo?.selected[0]?.amount
            : "",
          currency: "CLP",
          pay: manualDocumentInfo?.selected
            ? manualDocumentInfo?.selected[0]?.document?.meta?.pago
            : "2",
          repeat: manualDocumentInfo?.selected
            ? manualDocumentInfo?.selected[0]?.document?.meta?.interval
            : null,
        });
      }
    }
  }, [manualDocumentInfo?.selected]);

  useEffect(() => {
    if (!manualDocumentInfo?.selected) {
      setData({
        name: data?.name,
        entryType: data?.entryType,
        comment: data?.comment,
        area: data?.area,
        date: "",
        finalDate: "",
        amount: "",
        currency: "CLP",
        pay: "2",
      });
      setCredit({
        creditType: "comercial",
        bank: "bankBBVA",
        id: "",
        liquidAmount: "",
        currency: "CLP",
        paymentsAmount: "",
        payments: "",
        fees: "",
        feesPeriod: "mensual",
        finalDate: "",
        firstDate: "",
      });
    }
  }, [data?.entryType]);

  useEffect(() => {
    if (
      data?.entryType === "singleEntry" &&
      showDetail &&
      data?.area?.length > 0 &&
      parseFloat(data?.amount) > 0 &&
      data?.date?.length > 0
    ) {
      setButtonState(false);
    } else if (
      data.entryType === "recurrent" &&
      showDetail &&
      data?.area?.length > 0 &&
      data?.repeat?.length > 0 &&
      parseFloat(data.amount) > 0 &&
      data?.date?.length > 0 &&
      data?.finalDate?.length > 0
    ) {
      setButtonState(false);
    } else if (
      data.entryType === "initialBalance" &&
      showDetail &&
      parseFloat(data.amount) > 0
    ) {
      setButtonState(false);
    } else if (data.entryType === "credits" && showDetail) {
      if (
        credit.id.length > 0 &&
        credit.liquidAmount.length > 0 &&
        parseFloat(credit.liquidAmount) > 0 &&
        credit.payments.length > 0 &&
        parseFloat(credit.payments) > 0 &&
        parseFloat(credit.paymentsAmount) > 0 &&
        credit.paymentsAmount.length > 0 &&
        credit.fees.length > 0 &&
        credit.firstDate.length > 0 &&
        credit.finalDate.length > 0
      ) {
        setButtonState(false);
      } else {
        setButtonState(true);
      }
    } else {
      setButtonState(true);
    }
  }, [data, credit, credit.id]);

  const submitForm = async (e) => {
    e.preventDefault();
    sendSubmitForm(
      e,
      data,
      dispatch,
      postInitialBalance,
      closeMenu,
      companyId,
      postManualDocument,
      getDate,
      getEndDate,
      credit,
      createCreditsDocument,
      getCreditDate,
      getCreditEndDate
    );
  };

  const updateForm = async (value) => {
    value.preventDefault();
    sendUpdateForm(
      value,
      setLoading,
      data,
      dispatch,
      updateManualDocument,
      manualDocumentInfo,
      companyId,
      closeMenu,
      getEndDate,
      deleteManualDocument
    );
  };

  let allCategory = [];
  let uniqueCategory = [];

  if (areas?.data?.allCashflowAreas) {
    areas?.data?.allCashflowAreas?.forEach((area, index) => {
      allCategory.push(area?.category);
    });
    allCategory.forEach((category) => {
      if (!uniqueCategory.includes(category)) {
        uniqueCategory.push(category);
      }
    });
  }

  const onChangeData = (value, id) => {
    changeData(value, id, setData, setCredit, data, credit);
  };

  return (
    <div
      className={`rightsidebar-content-panel barRight ${panelClassName}`.trim()}
    >
      <form
        className="d-flex flex-column flex-grow-1"
        style={{ minHeight: 0, overflow: "hidden", width: "100%" }}
        onSubmit={() =>
          manualDocumentInfo?.selected ? updateForm : submitForm
        }
      >
        <Title title={title} closeMenu={closeMenu} onToggleExpand={onToggleExpand} isExpanded={isExpanded} />
        <div className="rightsidebar-content-body">
        {SelectedForm ? (
          <SelectedForm
            options={options}
            editData={editData}
            closeMenu={closeMenu}
            setDataFunction={setDataFunction}
            setCheckedTransactions={setCheckedTransactions}
          />
        ) : (
          forms.map((elem) => {
            switch (elem?.type) {
              case "textarea":
                return (
                  <TextArea
                    elem={elem}
                    commentVisited={commentVisited}
                    data={data}
                    setCommentVisited={setCommentVisited}
                    setData={setData}
                    messageError={messageError}
                  />
                );
              case "button":
                return <>{showDetail ? <Button /> : ""}</>;
              case "multiselect":
                return <MultiSelectComp elem={elem} />;
              case "subtitleTop":
                return <SubtitleTop elem={elem} />;
              case "subtitle":
                return <>{showDetail ? <SubtitleTop elem={elem} /> : ""}</>;
              case "footer":
                return <SubtitleFooter elem={elem} />;
              case "select":
                return (
                  <Select
                    elem={elem}
                    typeVisited={typeVisited}
                    data={data}
                    setTypeVisited={setTypeVisited}
                    setData={setData}
                    manualDocumentInfo={manualDocumentInfo}
                    messageError={messageError}
                  />
                );
              case "creditType":
                return (
                  <>
                    {showDetail && data.entryType === "credits" ? (
                      <CreditType
                        elem={elem}
                        typeVisited={typeVisited}
                        data={data}
                        setTypeVisited={setTypeVisited}
                        onChangeData={onChangeData}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "banks":
                return (
                  <>
                    {showDetail && data.entryType === "credits" ? (
                      <BankSelect
                        elem={elem}
                        setTypeVisited={setTypeVisited}
                        onChangeData={onChangeData}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "repeat":
                return (
                  <>
                    {showDetail && data.entryType === "recurrent" ? (
                      <RepeatSelect
                        elem={elem}
                        typeVisited={typeVisited}
                        data={data}
                        onChangeData={onChangeData}
                        manualDocumentInfo={manualDocumentInfo}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "pay":
                return (
                  <>
                    {(showDetail &&
                      data.entryType === "recurrent" &&
                      data.repeat === "30") ||
                      (showDetail &&
                        data.entryType === "recurrent" &&
                        data.repeat === 30) ||
                      (showDetail &&
                        data.entryType === "recurrent" &&
                        data.repeat === "60") ||
                      (showDetail &&
                        data.entryType === "recurrent" &&
                        data.repeat === 60) ||
                      (showDetail &&
                        data.entryType === "recurrent" &&
                        data.repeat === "90") ||
                      (showDetail &&
                        data.entryType === "recurrent" &&
                        data.repeat === 90) ? (
                      <PaySelect
                        elem={elem}
                        data={data}
                        typeVisited={typeVisited}
                        onChangeData={onChangeData}
                        manualDocumentInfo={manualDocumentInfo}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "currency":
                return (
                  <>
                    {showDetail ? (
                      <CurrencySelect
                        elem={elem}
                        data={data}
                        setData={setData}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "amount":
                return (
                  <>
                    {showDetail ? (
                      <InputAmount
                        elem={elem}
                        data={data}
                        formatMoney={formatMoney}
                        credit={credit}
                        onChangeData={onChangeData}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "identificator":
                return (
                  <>
                    {showDetail && data.entryType === "credits" ? (
                      <CreditId elem={elem} onChangeData={onChangeData} />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "paymentsAmount":
                return (
                  <>
                    {showDetail && data.entryType === "credits" ? (
                      <PaymentsAmount
                        elem={elem}
                        credit={credit}
                        onChangeData={onChangeData}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "payments":
                return (
                  <>
                    {showDetail && data.entryType === "credits" ? (
                      <Payments
                        elem={elem}
                        credit={credit}
                        onChangeData={onChangeData}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "fees":
                return (
                  <>
                    {showDetail && data.entryType === "credits" ? (
                      <Fees
                        elem={elem}
                        credit={credit}
                        onChangeData={onChangeData}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "feesPeriod":
                return (
                  <>
                    {showDetail && data.entryType === "credits" ? (
                      <FeesPeriod
                        elem={elem}
                        typeVisited={typeVisited}
                        data={data}
                        setTypeVisited={setTypeVisited}
                        credit={credit}
                        onChangeData={onChangeData}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "area":
                return (
                  <>
                    {(showDetail && data.entryType === "singleEntry") ||
                      (showDetail && data.entryType === "recurrent") ? (
                      // <Area
                      //   elem={elem}
                      //   onChangeData={onChangeData}
                      //   data={data}
                      //   uniqueCategory={uniqueCategory}
                      //   GetHeaders={getFullHeaders}
                      //   areas={areas}
                      // />
                      <></>
                    ) : (
                      ""
                    )}
                  </>
                );
              case "name":
                return (
                  <Name
                    elem={elem}
                    nameVisited={nameVisited}
                    data={data}
                    setNameVisited={setNameVisited}
                    setData={setData}
                    messageError={messageError}
                  />
                );
              case "date":
                return (
                  <>
                    {(showDetail && data.entryType === "singleEntry") ||
                      (showDetail && data.entryType === "recurrent") ||
                      (showDetail && data.entryType === "credits") ? (
                      <FirstDate
                        data={data}
                        elem={elem}
                        credit={credit}
                        onChangeData={onChangeData}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "finalDate":
                return (
                  <>
                    {(showDetail && data.entryType === "recurrent") ||
                      (showDetail && data.entryType === "credits") ? (
                      <LastDate
                        data={data}
                        elem={elem}
                        credit={credit}
                        onChangeData={onChangeData}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              case "multiple":
                return <Multiple elem={elem} />;
              default:
                break;
            }
          })
        )}
        {showDetail ? (
          <>
            {manualDocumentInfo?.selected ? (
              loading ? (
                <div className="innerLoading">
                  <div className="innerLoading__spinner"></div>
                </div>
              ) : (
                "" //<ButtonGroup updateForm={updateForm} />
              )
            ) : (
              <SubmitButton
                disabled={buttonState}
                submitForm={submitForm}
                icon={iconAgregar}
                text={"Agregar fuente"}
              />
            )}
          </>
        ) : (
          ""
        )}
        </div>
      </form>
    </div>
  );
};

export default Form;
